import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=398dc275&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./batchNumberDetail.vue?vue&type=style&index=0&id=398dc275&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398dc275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398dc275')) {
      api.createRecord('398dc275', component.options)
    } else {
      api.reload('398dc275', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=398dc275&scoped=true", function () {
      api.rerender('398dc275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/customerAccount/cmp/batchNumberDetail.vue"
export default component.exports